// src/app/animations.ts

import { trigger, transition, style, query, group, animate } from '@angular/animations';

export const slideInAnimation =
  trigger('routeAnimations', [
    // Login -> Dashboard (entrada a la app)
    transition('LoginPage => DashboardPage', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 })
      ], { optional: true }),
      group([
        query(':leave', [
          animate('400ms ease-out', style({ transform: 'translateX(-20%)', opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate('400ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
        ], { optional: true })
      ])
    ]),

    // Dashboard -> CourseView (ver detalles del curso)
    transition('DashboardPage => CourseViewPage', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 })
      ], { optional: true }),
      group([
        query(':leave', [
          animate('400ms ease-out', style({ transform: 'translateY(-20%)', opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate('400ms ease-out', style({ transform: 'translateY(0%)', opacity: 1 }))
        ], { optional: true })
      ])
    ]),

    // CourseView -> CoursePlayer (reproducir curso)
    transition('CourseViewPage => CoursePlayerPage', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 })
      ], { optional: true }),
      group([
        query(':leave', [
          animate('400ms ease-out', style({ transform: 'translateX(-30%)', opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate('400ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
        ], { optional: true })
      ])
    ]),

    // CoursePlayer -> CourseView (volver a detalles)
    transition('CoursePlayerPage => CourseViewPage', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ transform: 'translateX(-30%)', opacity: 0 })
      ], { optional: true }),
      group([
        query(':leave', [
          animate('400ms ease-out', style({ transform: 'translateX(100%)', opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate('400ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
        ], { optional: true })
      ])
    ]),

    // CourseView -> Dashboard (volver al dashboard)
    transition('CourseViewPage => DashboardPage', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ transform: 'translateY(-20%)', opacity: 0 })
      ], { optional: true }),
      group([
        query(':leave', [
          animate('400ms ease-out', style({ transform: 'translateY(100%)', opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate('400ms ease-out', style({ transform: 'translateY(0%)', opacity: 1 }))
        ], { optional: true })
      ])
    ]),

    // CoursePlayer -> Dashboard (volver directo al dashboard)
    transition('CoursePlayerPage => DashboardPage', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ transform: 'translateX(-30%)', opacity: 0 })
      ], { optional: true }),
      group([
        query(':leave', [
          animate('400ms ease-out', style({ transform: 'translateX(100%)', opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate('400ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
        ], { optional: true })
      ])
    ]),

    // Dashboard -> Login (logout)
    transition('DashboardPage => LoginPage', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ transform: 'translateX(-20%)', opacity: 0 })
      ], { optional: true }),
      group([
        query(':leave', [
          animate('400ms ease-out', style({ transform: 'translateX(100%)', opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate('400ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
        ], { optional: true })
      ])
    ]),

    // Dashboard -> Profile (dentro del layout)
    transition('DashboardPage => ProfilePage', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 })
      ], { optional: true }),
      group([
        query(':leave', [
          animate('400ms ease-out', style({ transform: 'translateX(-20%)', opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate('400ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
        ], { optional: true })
      ])
    ]),

    // Profile -> Dashboard (volver)
    transition('ProfilePage => DashboardPage', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ transform: 'translateX(-20%)', opacity: 0 })
      ], { optional: true }),
      group([
        query(':leave', [
          animate('400ms ease-out', style({ transform: 'translateX(100%)', opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate('400ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
        ], { optional: true })
      ])
    ]),

    // CoursePlayer -> Exam (ir a examen)
    transition('CoursePlayerPage => ExamPage', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 })
      ], { optional: true }),
      group([
        query(':leave', [
          animate('400ms ease-out', style({ transform: 'translateY(-20%)', opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate('400ms ease-out', style({ transform: 'translateY(0%)', opacity: 1 }))
        ], { optional: true })
      ])
    ]),

    // Exam -> Dashboard (salir del examen)
    transition('ExamPage => DashboardPage', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ transform: 'translateY(-20%)', opacity: 0 })
      ], { optional: true }),
      group([
        query(':leave', [
          animate('400ms ease-out', style({ transform: 'translateY(100%)', opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate('400ms ease-out', style({ transform: 'translateY(0%)', opacity: 1 }))
        ], { optional: true })
      ])
    ]),

    // Calendar -> LiveClass (ir a clase en vivo)
    transition('CalendarPage => LiveClassPage', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 })
      ], { optional: true }),
      group([
        query(':leave', [
          animate('400ms ease-out', style({ transform: 'translateX(-30%)', opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate('400ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
        ], { optional: true })
      ])
    ]),

    // LiveClass -> Calendar (volver al calendario)
    transition('LiveClassPage => CalendarPage', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ transform: 'translateX(-30%)', opacity: 0 })
      ], { optional: true }),
      group([
        query(':leave', [
          animate('400ms ease-out', style({ transform: 'translateX(100%)', opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate('400ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
        ], { optional: true })
      ])
    ]),

    // CoursesList -> CourseView (ver detalles desde listado)
    transition('CoursesListPage => CourseViewPage', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 })
      ], { optional: true }),
      group([
        query(':leave', [
          animate('400ms ease-out', style({ transform: 'translateY(-20%)', opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate('400ms ease-out', style({ transform: 'translateY(0%)', opacity: 1 }))
        ], { optional: true })
      ])
    ])
  ]);

